<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <v-layout align-center justify-start row fill-height>
          <v-layout align-start justify-start column fill-height>
            <v-layout align-start justify-start row fill-height class="pa-3">
              <span class="headline"> Welcome</span>
            </v-layout>
            <v-layout align-center justify-start row fill-height class="pl-3 pb-3">
              <v-icon color="green accent-2">mdi-alert-decagram</v-icon>
              <span class="pl-2"> To the Strata Title Inspection Program</span>
            </v-layout>
          </v-layout>
        </v-layout>
      </v-flex>
      <v-flex xs6>
        <v-layout align-center justify-end row fill-height>
          <!--<div class="text-xs-center">
            <v-dialog v-model="dialog" width="500">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" rounded color="primary" dark
                  >View Privacy Policy</v-btn
                >
              </template>

              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                  Privacy Policy
                </v-card-title>

                <v-card-text>
                  You Have Attested to Being the Authorised Person for Sites You
                  Enter in this Portal.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="dialog = false">
                    OK
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>-->
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex
        xs12
        md3
        class="pb-3 pt-3"
        v-for="(card, i) in cards"
        v-bind:key="i"
      >
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="subtitle-2">{{ card.title }}</div>
              <h2 v-if="i==0" class="display-2 mb-0" :class="card.color">
                {{ totalSites }}
              </h2>

              <h2 v-if="i==1" class="display-2 mb-0" :class="card.color">
                {{ inProgress }}
              </h2>
              <h2 v-if="i==2" class="display-2 mb-0" :class="card.color">
                {{ completed }}
              </h2>
              <h2 v-if="i==3" class="display-2 mb-0" :class="card.color">
                {{ delivered }}
              </h2>

            </div>
          </v-card-title>

          <v-layout align-center justify-end row fill-height class="pr-3 pb-3">
            <v-icon style="font-size: 60px;" :color="card.iconColor">{{
              card.icon
            }}</v-icon>
          </v-layout>
        </v-card>
      </v-flex>

    </v-layout>

    <v-layout row cols="12" sm="12" >
      <v-flex xs12>
      <template >
          <div v-for="(item, index) in items" v-bind:key="index">
        <Progress :site="item"></Progress>
          </div>
      </template>
      </v-flex>
    </v-layout>

    <v-layout row wrap>

      <v-flex xs12 class="pt-3 pb-3">
        <v-card>
          <!--<Map></Map>-->
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
.frappe-chart {
  width: 95%;
}

.container {
  padding-left: 10px;
  padding-right: 10px;
}
.stip-green {
  color: #1de9b6;
}
.stip-blue {
  color: #4cabdb;
}
.stip-purple {
  color: #5c6dae;
}
.stip-light-green {
  color: #6fe2d5;
}
</style>

<script>
import Map from "./Map.vue";
import Progress from "./Progress.vue";
import { mapState } from "vuex";
import { router } from "../router";
import jwt_decode from "jwt-decode";
import { checkLogin } from '../helpers/check'


export default {
  name: "Dash",
  components: {
    Progress
  },
  data() {
    return {
      dialog: false,
      cards: [
        {
          title: "Total Sites",
          data: this.totalSites,
          icon: "mdi-map-marker",
          color: "stip-purple",
          iconColor: "#5C6DAE"
        },
        {
          title: "Inspections in Progress",
          data: 0,
          icon: "mdi-clipboard-list",
          color: "stip-light-green",
          iconColor: "#6FE2D5"
        },
        {
          title: "Inspections Completed",
          data: 0,
          icon: "mdi-check-all",
          color: "stip-blue",
          iconColor: "#4CABDB"
        },
        {
          title: "Reports Delivered",
          data: 0,
          icon: "mdi-chart-line-variant",
          color: "stip-green",
          iconColor: "#1DE9B6"
        },
      ]
    };
  },
  created() {
  },
  computed: {
    ...mapState("sites", {
      items: state => state.sites,
      totalSites(state) {
        return state.sites.length;
      },
      inProgress(state){
        let filtered = state.sites.filter(function(item){
          return ( item.inspection_status.toString() === "S" ||
            item.inspection_status.toString() === "A")
        });
        return filtered.length;
      },
      completed(state){
        let filtered = state.sites.filter(function(item){
          return ( item.inspection_status.toString() === "C" )
        });
        return filtered.length;
      },
      delivered(state){
        let filtered = state.sites.filter(function(item){
          return ( item.inspection_status.toString() === "D" )
        });
        return filtered.length;
      }
    }),
    alert () {
      return this.$store.state.alert
    }
  },
  mounted: function() {
    this.checkLoggedIn();
  },
  methods: {
    checkLoggedIn() {
      if (checkLogin()) {
        router.push("/login");
      }
      else{
          this.$store.dispatch("sites/getSites").then(
              () => {
              },
              error => {
              }
          );
      }

    },
    inspectToken() {
      const token = this.$session.has("token");
      if (token) {
        const decoded = jwt_decode(sessionStorage.getItem("token"));
        const exp = decoded.exp;
        const orig_iat = decoded.orig_iat;

        if (exp - Date.now() / 1000 < 1800) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  }
};
</script>
